import { AnimationTriggerMetadata, animate, style, transition, trigger } from '@angular/animations';

interface Animations {
  animations: AnimationTriggerMetadata[];
}

export const Animations: Animations = {
  animations: [
    trigger('fade-in-out', [
      transition(
        ':enter',
        [
          style({ opacity: 0, position: '{{position}}' }),
          animate('{{duration}} {{delay}} ease-in-out', style({ opacity: '{{in}}', position: '{{position}}' })),
        ],
        { params: { in: 1, out: 0, position: '', duration: '0.3s', delay: '0s' } },
      ),
      transition(
        ':leave',
        [
          style({ opacity: '{{in}}', position: '{{position}}' }),
          animate('{{duration}} {{delay}} ease-in-out', style({ opacity: 0, position: '{{position}}' })),
        ],
        { params: { in: 1, out: 0, position: '', duration: '0.3s', delay: '0s' } },
      ),
    ]),
    trigger('smooth-appear', [
      transition(':enter', [
        style({ opacity: 0, height: '0px' }),
        animate('0.5s ease-in-out', style({ opacity: 1, height: '100%' })),
      ]),
    ]),
    trigger('fade-in', [
      transition(':enter', [style({ opacity: 0 }), animate('0.4s ease-in-out', style({ opacity: 1 }))]),
    ]),
    trigger('fade-out', [
      transition(':leave', [style({ opacity: 1 }), animate('0.4s ease-in-out', style({ opacity: 0 }))]),
    ]),
  ],
};
